import { AllowListPhoneNumberCreateInput, AllowListPhoneNumberUpdateInput } from '@occc/graphql';
import { formatPhoneNumberToE164 } from '@occc/utils-phone-number';

import { UpsertAllowListPhoneNumberFormValues } from './create-comment-modal.types';

export const convertAllowListPhoneNumberFormValuesToCreateInput = (
  formValues: UpsertAllowListPhoneNumberFormValues,
): AllowListPhoneNumberCreateInput => {
  return {
    // TODO: This function must return a valid phone number because we did validation
    phoneNumber: formatPhoneNumberToE164(formValues.phoneNumber) ?? '',
    name: formValues.name,
    reason: formValues.reason,
  };
};

export const convertAllowListPhoneNumberFormValuesToUpdateInput = (
  formValues: UpsertAllowListPhoneNumberFormValues,
  uuid: string,
): AllowListPhoneNumberUpdateInput => {
  return {
    name: formValues.name,
    reason: formValues.reason,
    uuid,
  };
};
